import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import PageLoader from '../../../../Themes/Layout/PageLoader';
import { Breadcrumbs, H3, H4, Span } from '../../../../Themes/Components/AbstractElements';
import { formatNumber } from '../../../../utils/formatacoes';
import authService from '../../../../Services/Auth/authService';
import RegimeMercadoriasService from '../../../../Services/Regime/RegimeMercadoriasService';
import MovimentacoesTimeline from './components/movimentacoesTimeline';
import TotaisTributosTable from './components/totaisTributosTable';
import HistoricoTributos from './components/historicoTributos';

const RegimeMercadoriasView = () => {
  const [mercadoriaData, setMercadoriaData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const view = async () => {
      try {
        const data = await RegimeMercadoriasService.view(id);

        setMercadoriaData(data);
        setLoading(false);
      } catch (error) {
        toast.error(error.message);
        navigate('/regime/mercadorias');
      }
    };

    view();
  }, [id]);

  const dados = mercadoriaData?.dados_mercadoria;

  const temAcessoProdutos = authService
    .getMenus()
    .some((menu) => menu.children?.some((children) => children.path?.startsWith('/cadastro/produtos')));

  return (
    <>
      <PageLoader loaded={loading} />
      <Breadcrumbs mainTitle={`Mercadoria ${dados?.numero_serie ?? ''}`} title='Mercadorias' parent='Regime' />

      <div className='container-fluid'>
        <div className='row'>
          <div className='col-xl-12'>
            <div className='row'>
              <div className='col-xl-12'>
                <div className='card'>
                  <div className='card-body'>
                    <H3>Dados da Mercadoria</H3>
                    <div className='row mb-2'>
                      <div className='col-sm-12'>
                        <H4>Importador</H4>
                        <Span>{dados?.importador}</Span>
                      </div>
                    </div>

                    <div className='row mb-2'>
                      <div className='col-md-2'>
                        <H4>Part Number</H4>
                        <Span>{dados?.partnumber}</Span>
                      </div>
                      <div className='col-md-1'>
                        <H4>Código P.U.</H4>
                        <Span>{dados?.produto_codigo_pu}</Span>
                      </div>
                      <div className='col-md-1'>
                        <H4>Versão</H4>
                        <Span>{dados?.produto_versao}</Span>
                      </div>
                      <div className='col-md-3'>
                        <H4>Nome</H4>
                        {temAcessoProdutos && dados?.produto_id ? (
                          <Link to={`/cadastro/produtos/view/${dados.produto_id}`}>{dados.produto_nome}</Link>
                        ) : (
                          <Span>{dados?.produto_nome}</Span>
                        )}
                      </div>
                      <div className='col-md-5'>
                        <H4>Descrição do Produto</H4>
                        <Span>{dados?.produto_descricao}</Span>
                      </div>
                    </div>

                    <div className='row mb-2'>
                      <div className='col-sm-3'>
                        <H4>S/N</H4>
                        <Span>{dados?.numero_serie}</Span>
                      </div>
                      <div className='col-sm-3'>
                        <H4>Lote</H4>
                        <Span>{dados?.numero_lote}</Span>
                      </div>
                      <div className='col-sm-3'>
                        <H4>Data de Entrada</H4>
                        <Span>{dados?.data_entrada}</Span>
                      </div>
                      <div className='col-sm-3'>
                        <H4>Data de Vencimento</H4>
                        <Span>{dados?.data_vencimento}</Span>
                      </div>
                      <div className='col-sm-3'>
                        <H4>Situação</H4>
                        <Span>{dados?.situacao}</Span>
                      </div>
                    </div>

                    <div className='row mb-2'>
                      <div className='col-md-2'>
                        <H4>Qtde. Comercializada</H4>
                        <Span>{formatNumber(dados?.qtde_comerc, 2) ?? '-'}</Span>
                      </div>
                      <div className='col-md-2'>
                        <H4>Unidade Comercializada</H4>
                        <Span>{dados?.unid_comerc}</Span>
                      </div>
                      <div className='col-md-2'>
                        <H4>Qtde. Estatística</H4>
                        <Span>{formatNumber(dados?.qtde_estat, 2) ?? '-'}</Span>
                      </div>
                      <div className='col-md-2'>
                        <H4>Unidade Estatística</H4>
                        <Span>{dados?.unidade_estatistica}</Span>
                      </div>
                      <div className='col-md-2'>
                        <H4>Peso Bruto</H4>
                        <Span>{formatNumber(dados?.peso_bruto, 5) ?? '-'}</Span>
                      </div>
                      <div className='col-md-2'>
                        <H4>Peso Líquido</H4>
                        <Span>{formatNumber(dados?.peso_liquido, 5) ?? '-'}</Span>
                      </div>
                    </div>

                    <div className='row mb-2'>
                      <div className='col-sm-4'>
                        <H4>VMLE</H4>
                        <Span>{formatNumber(dados?.vlme_moeda, 2, dados?.moeda ?? '-')}</Span>
                      </div>
                      <div className='col-sm-4'>
                        <H4>Frete</H4>
                        <Span>{formatNumber(dados?.frete_valor_moeda, 2, dados?.frete_moeda) ?? '-'}</Span>
                      </div>
                      <div className='col-sm-4'>
                        <H4>Seguro</H4>
                        <Span>{formatNumber(dados?.seguro_valor_moeda, 2, dados?.seguro_moeda) ?? '-'}</Span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-xl-12'>
                <div className='card'>
                  <div className='card-body'>
                    <H3>Movimentações</H3>
                    <div className='row'>
                      <div className='col-xl-12'>
                        <MovimentacoesTimeline movimentacoes={mercadoriaData?.movimentacoes} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-xl-12'>
                <div className='card'>
                  <div className='card-body'>
                    <H3>Totais dos Tributos</H3>
                    <div className='row'>
                      <div className='col-xl-12'>
                        <TotaisTributosTable
                          tributos={mercadoriaData?.totais_tributos?.tributos}
                          totais={mercadoriaData?.totais_tributos?.totais}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='row'>
              <div className='col-xl-12'>
                <div className='card'>
                  <div className='card-body'>
                    <H3>Histórico dos Tributos</H3>
                    <div className='row'>
                      <div className='col-xl-12'>
                        <HistoricoTributos id={id} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegimeMercadoriasView;
